import React from "react";
import Dashboard from "../Dashboard"
import MenuPage from "../settings/Menu";
import EmployeePage from "../masters/Employee";
import MenuPermission from "../settings/MenuPermission"
import RolePage from "../settings/Role";
import ConsigneesPage from "../masters/Consignees";
import LinerPage from "../masters/Liner";
import PortPage from "../masters/Port";
import CfsLocationPage from "../masters/Cfs_location";
import LicensePage from "../compliance/License";
import BondPage from "../compliance/Bond";
import BankGuaranteePage from "../compliance/Bank_guarantee";
import AllJobsPage from "../jobs/All_jobs";
import JobHistoryPage from "../jobs/Job_history";
import BePendingPage from "../jobs/Be_pending";
import ContainersPage from "../jobs/Containers";
import OutstandingPage from "../Finance/Outstanding";
import BillsPage from "../Finance/Bills";
import PaymentsPage from "../Finance/Payments";
import DispatchPage from "../operations/Despatch";
import CFSStatusPage from "../operations/Cfs_status";
import TrucksPendingPage from "../operations/Trucks_pending";
import ShipperPage from "../masters/Shipper";
import CourierPage from "../masters/Courier";
import CommodityPage from "../masters/Commodity";
import IndentingAgentPage from "../masters/Indenting_agent";
import TransporterPage from "../masters/Transporter";
import TruckPage from "../masters/Truck";
import CurrencyPage from "../masters/Currency";

// ── Reports ────────────────────────────────────────────────────────────────
import DailyStatusReport from "../reports/Daily_status_report";
import ArrivedStatusReport from "../reports/Arrived_status_report";
import ArrivalStatusAllJobs from "../reports/Arrival_status_all_jobs";
import BillOfEntryReport from "../reports/Bill_of_entry_report";
import ReadyToDespatchReport from "../reports/Ready_to_despatch_report";
import DailyDespatchReport from "../reports/Daily_despatch_report";
import CfsWiseArrivalStatus from "../reports/Cfs_wise_arrival_status";
import OutstandingStatement from "../reports/Outstanding_statement";
import LicenseLedger from "../reports/License_ledger";
import NotReachedTruck from "../reports/Not_reached_truck";
import DespatchPartyWiseReport from "../reports/Despatch_party_wise_report";


const protectedRoutes = [
  { path: "dashboard", element: <Dashboard /> },
  { path: "settings/menu", element: <MenuPage /> },
  { path: "masters/Employee", element: <EmployeePage /> },
  { path: "settings/menu_permission", element: <MenuPermission /> },
  { path: "settings/role", element: <RolePage /> },
  { path: "masters/consignees", element: <ConsigneesPage /> },
  { path: "masters/liner", element: <LinerPage /> },
  { path: "masters/port", element: <PortPage /> },
  { path: "masters/cfs_location", element: <CfsLocationPage /> },
  { path: "compliance/license", element: <LicensePage /> },
  { path: "compliance/bond", element: <BondPage /> },
  { path: "compliance/bank_guarantee", element: <BankGuaranteePage /> },
  { path: "jobs/all_jobs", element: <AllJobsPage /> },
  { path: "jobs/job_history", element: <JobHistoryPage /> },
  { path: "jobs/be_pending", element: <BePendingPage /> },
  { path: "jobs/containers", element: <ContainersPage /> },
  { path: "finance/outstanding", element: <OutstandingPage /> },
  { path: "finance/bills", element: <BillsPage /> },
  { path: "finance/payments", element: <PaymentsPage /> },
  { path: "operations/despatch", element: <DispatchPage /> },
  { path: "operations/cfs_status", element: <CFSStatusPage /> },
  { path: "operations/trucks_pending", element: <TrucksPendingPage /> },
  { path: "masters/shipper", element: <ShipperPage /> },
  { path: "masters/courier", element: <CourierPage /> },
  { path: "masters/commodity", element: <CommodityPage /> },
  { path: "masters/indenting_agent", element: <IndentingAgentPage /> },
  { path: "masters/transporter", element: <TransporterPage /> },
  { path: "masters/truck", element: <TruckPage /> },
  { path: "masters/currency", element: <CurrencyPage /> },
  // ── Reports ─────────────────────────────────────────────────────────────
  { path: "reports/daily_status", element: <DailyStatusReport /> },
  { path: "reports/arrived_status", element: <ArrivedStatusReport /> },
  { path: "reports/arrival_status", element: <ArrivalStatusAllJobs /> },
  { path: "reports/bill_of_entry", element: <BillOfEntryReport /> },
  { path: "reports/ready_to_despatch", element: <ReadyToDespatchReport /> },
  { path: "reports/daily_despatch", element: <DailyDespatchReport /> },
  { path: "reports/cfs_wise_arrival", element: <CfsWiseArrivalStatus /> },
  { path: "reports/outstanding_statement", element: <OutstandingStatement /> },
  { path: "reports/license_ledger", element: <LicenseLedger /> },
  { path: "reports/not_reached_truck", element: <NotReachedTruck /> },
  { path: "reports/despatch_party_wise_report", element: <DespatchPartyWiseReport /> },

]

export default protectedRoutes;